import { render, staticRenderFns } from "./OrthoShoulderDislocation.vue?vue&type=template&id=023da0cc&scoped=true"
import script from "./OrthoShoulderDislocation.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderDislocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023da0cc",
  null
  
)

export default component.exports